import { createSlice } from '@reduxjs/toolkit';

import { callerCreator } from '../callerCreator';

const initialState = {
  auto: {
    loading: true,
    loadingQuotes: false,
    isLoadingVehicleModels: false,
    isLoadingVehicleVersions: false,
    isLoadingFastQuote: false,
    isSubmitting: false,
    index: 1,
    states: [],
    municipalities: [],
    vehicleModels: [],
    dataPrivacy: [],
    brands: [],
    formData: {
      qualifications: [],
      professions: [],
      parking_types: [],
      theft_protections: [],
      marital_statuses: [],
      insurance_companies: [],
      company_types: [],
    },
    vehicleVersions: [],

    driverForm: false,
    ownerForm: false,

    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,

    fastQuoteVehicleInfo: null,
  },
  autocarro: {
    loading: true,
    isLoadingVehicleModels: false,
    isLoadingVehicleVersions: false,
    isLoadingFastQuote: false,
    isSubmitting: false,
    index: 1,
    states: [],
    municipalities: [],
    vehicleModels: [],
    dataPrivacy: [],
    brands: [],
    formData: {
      qualifications: [],
      professions: [],
      parking_types: [],
      theft_protections: [],
      marital_statuses: [],
      insurance_companies: [],
      company_types: [],
    },
    vehicleVersions: [],
    vehicleActivities: [],

    driverForm: false,
    ownerForm: false,

    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,

    fastQuoteVehicleInfo: null,
  },
  profession: {
    loading: true,
    states: [],
    municipalities: [],
    professions: [],
    selectedProfession: null,
    formData: {},

    dataPrivacy: [],

    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
  },
  infortuni: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {
      qualifications: [],
      professions: [],
      parking_types: [],
      theft_protections: [],
      marital_statuses: [],
      insurance_companies: [],
      company_types: [],
    },
    dataPrivacy: [],

    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,

    pack: '',
    isActive: '',
    index: 1,
    isEntry: false,
    requestToken: '',
  },
  travel: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
    travel_states: [],
  },
  commercial: {
    loading: true,
    step: 1,
    states: [],
    dataPrivacy: [],
    municipalities: [],
    company_types: [
      {
        id: 1,
        label: 'COLTIVAZIONE DI COLTURE AGRICOLE NON PERMANENTI',
        name: 'COLTIVAZIONE DI COLTURE AGRICOLE NON PERMANENTI',
      },

      {
        id: 2,
        label:
          'Coltivazione di cereali (escluso il riso), legumi da granella e semi oleosi',
        name: 'Coltivazione di cereali (escluso il riso), legumi da granella e semi oleosi',
      },
      {
        id: 3,
        label: 'Coltivazione di cereali (escluso il riso)',
        name: 'Coltivazione di cereali (escluso il riso)',
      },
      {
        id: 4,
        label: 'Coltivazione di semi oleosi',
        name: 'Coltivazione di semi oleosi',
      },
      {
        id: 5,
        label: 'Coltivazione di legumi da granella',
        name: 'Coltivazione di legumi da granella',
      },
      { id: 6, label: 'Coltivazione di riso', name: 'Coltivazione di riso' },
      {
        id: 7,
        label:
          'COLTIVAZIONI AGRICOLE E PRODUZIONE DI PRODOTTI ANIMALI, CACCIA E SERVIZI CONNESSI',
        name: 'COLTIVAZIONI AGRICOLE E PRODUZIONE DI PRODOTTI ANIMALI, CACCIA E SERVIZI CONNESSI',
      },
    ],
  },
  motorcycle: {
    loading: true,
    loadingQuotes: false,
    isLoadingVehicleModels: false,
    isLoadingVehicleVersions: false,
    isLoadingFastQuote: false,
    isSubmitting: false,
    index: 1,
    states: [],
    municipalities: [],
    vehicleModels: [],
    dataPrivacy: [],
    brands: [],
    formData: {
      qualifications: [],
      professions: [],
      parking_types: [],
      theft_protections: [],
      marital_statuses: [],
      insurance_companies: [],
      company_types: [],
    },
    vehicleVersions: [],

    driverForm: false,
    ownerForm: false,

    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,

    fastQuoteVehicleInfo: null,
  },
  tutela_legale: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
  },
  house: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
    loadingQuotes: false,
  },
  salute: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
  },
  ancillari_auto: {
    loading: true,
    isLoadingVehicleModels: false,
    isLoadingVehicleVersions: false,
    isLoadingFastQuote: false,
    states: [],
    index: 1,
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
    brands: [],
    vehicleModels: [],
    vehicleVersions: [],
    fastQuoteVehicleInfo: null,
    loadingQuotes: false,
  },
  sanitaria_stranieri: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
  },
  professionale_sanita: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
  },
  public_employment: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
  },
  malattia: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
  },
  infortunio: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
  },
  condominio: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
  },
  rc_famiglia: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
  },
  facileCompanies: [],
  monopattini: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    searchResults: [],
    selectedClientOldData: null,
    selectedClient: null,
    selectedClientId: null,
  },
};

export const formsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    autoFormDataUpdated: (state, { payload }) => {
      state.auto = { ...state.auto, ...payload };
    },
    resetAutoForm: (state) => {
      state.auto = { ...initialState.auto };
    },
    autocarroFormDataUpdated: (state, { payload }) => {
      state.autocarro = { ...state.autocarro, ...payload };
    },
    resetAutocarroForm: (state) => {
      state.autocarro = { ...initialState.autocarro };
    },
    professionFormDataUpdated: (state, { payload }) => {
      state.profession = { ...state.profession, ...payload };
    },
    resetProfessionForm: (state) => {
      state.profession = { ...initialState.profession };
    },
    infortuniFormDataUpdated: (state, { payload }) => {
      state.infortuni = { ...state.infortuni, ...payload };
    },
    resetInfortuniForm: (state) => {
      state.infortuni = { ...initialState.infortuni };
    },
    travelFormDataUpdated: (state, { payload }) => {
      state.travel = { ...state.travel, ...payload };
    },
    resetTravelForm: (state) => {
      state.travel = { ...initialState.travel };
    },
    houseFormDataUpdated: (state, { payload }) => {
      state.house = { ...state.house, ...payload };
    },
    resetHouseForm: (state) => {
      state.house = { ...initialState.house };
    },
    commercialFormDataUpdated: (state, { payload }) => {
      state.commercial = { ...state.commercial, ...payload };
    },
    resetCommercialForm: (state) => {
      state.commercial = { ...initialState.commercial };
    },

    motoFormDataUpdated: (state, { payload }) => {
      state.motorcycle = { ...state.motorcycle, ...payload };
    },
    resetMotoForm: (state) => {
      state.motorcycle = { ...initialState.motorcycle };
    },

    tutelaLegaleFormDataUpdated: (state, { payload }) => {
      state.tutela_legale = { ...state.tutela_legale, ...payload };
    },
    resetTutelaLegaleForm: (state) => {
      state.tutela_legale = { ...initialState.tutela_legale };
    },
    saluteFormDataUpdated: (state, { payload }) => {
      state.salute = { ...state.salute, ...payload };
    },
    resetSaluteForm: (state) => {
      state.salute = { ...initialState.salute };
    },
    ancillariAutoFormDataUpdated: (state, { payload }) => {
      state.ancillari_auto = { ...state.ancillari_auto, ...payload };
    },
    resetAncillariAutoForm: (state) => {
      state.ancillari_auto = { ...initialState.ancillari_auto };
    },
    sanitariaStranieriFormDataUpdated: (state, { payload }) => {
      state.sanitaria_stranieri = { ...state.sanitaria_stranieri, ...payload };
    },
    resetSanitariaStranieriForm: (state) => {
      state.sanitaria_stranieri = { ...initialState.sanitaria_stranieri };
    },
    professionaleSanitaFormDataUpdated: (state, { payload }) => {
      state.professionale_sanita = { ...state.professionale_sanita, ...payload };
    },
    resetProfessionaleSanitaForm: (state) => {
      state.professionale_sanita = { ...initialState.professionale_sanita };
    },
    publicEmploymentFormDataUpdated: (state, { payload }) => {
      state.public_employment = { ...state.public_employment, ...payload };
    },
    resetPublicEmploymentForm: (state) => {
      state.public_employment = { ...initialState.public_employment };
    },
    malattiaFormDataUpdated: (state, { payload }) => {
      state.malattia = { ...state.malattia, ...payload };
    },
    resetMalattiaForm: (state) => {
      state.malattia = { ...initialState.malattia };
    },
    infortunioFormDataUpdated: (state, { payload }) => {
      state.infortunio = { ...state.infortunio, ...payload };
    },
    resetInfortunioForm: (state) => {
      state.infortunio = { ...initialState.infortunio };
    },
    condominioFormDataUpdated: (state, { payload }) => {
      state.condominio = { ...state.condominio, ...payload };
    },
    resetCondominioForm: (state) => {
      state.condominio = { ...initialState.condominio };
    },
    rcFamigliaFormDataUpdated: (state, { payload }) => {
      state.rc_famiglia = { ...state.rc_famiglia, ...payload };
    },
    resetRcFamigliaForm: (state) => {
      state.rc_famiglia = { ...initialState.rc_famiglia };
    },
    facileCompaniesUpdated: (state, { payload }) => {
      state.facileCompanies = payload ?? [];
    },
    monopattiniFormDataUpdated: (state, { payload }) => {
      state.monopattini = { ...state.monopattini, ...payload };
    },
    resetMonopattiniForm: (state) => {
      state.monopattini = { ...initialState.monopattini };
    },
  },
});

export default callerCreator(formsSlice.actions);
